import { FaSquare } from '@meronex/icons/fa';
import React from 'react';
import {
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

export function getPriorityHandler(priority: string | undefined) {
  let prio;
  if (priority?.includes('priority0')) prio = 'priorityNone';
  if (priority?.includes('priority1')) prio = 'priorityLow';
  if (priority?.includes('priority2')) prio = 'priorityNormal';
  if (priority?.includes('priority3')) prio = 'priorityHigh';
  if (priority?.includes('priority4')) prio = 'priorityUrgent';
  return prio;
}
const NoMemoPriorityRenderer: TResponsiveTableCellRenderer<{ src: string }> =
  React.forwardRef<
    HTMLTableCellElement,
    TResponsiveTableCellRendererProps<{ src: string }>
  >(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
        row,
        ...props
      },
      currentRef,
    ) => {
      const taskPriorityColor = getPriorityHandler(rendererProps?.src);
      return (
        <td
          {...props}
          {...cell}
          ref={currentRef}
          className="priority"
          sx={{
            color: taskPriorityColor,
          }}
        >
          <FaSquare />
        </td>
      );
    },
  );
NoMemoPriorityRenderer.displayName = 'PriorityRenderer';
export const PriorityRenderer = NoMemoPriorityRenderer;
